import { callApi } from './ApiClient';

const DEFAULT_CORPORATE_NUMBER_ASSIGN_TIMEOUT_MS = 180000;

const getCorporations = (data, dispatch) => {
  return callApi('GET', '/corporations', data, dispatch);
}

const getCorporationsById = (id, data, dispatch) => {
  return callApi('GET', `/corporations/${id}`, data, dispatch);
}

const postAssignCorporateNumber = (data, dispatch) => {
  const timeoutMs =
    Number(process.env.REACT_APP_CORPORATE_NUMBER_ASSIGN_TIMEOUT_MS) ||
    DEFAULT_CORPORATE_NUMBER_ASSIGN_TIMEOUT_MS;

  return callApi('POST', '/corporations/assign-corporate-number', data, dispatch, false, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: timeoutMs,
  });
}

const postAssignCorporateNumberAsync = (data, dispatch) => {
  const timeoutMs =
    Number(process.env.REACT_APP_CORPORATE_NUMBER_ASSIGN_TIMEOUT_MS) ||
    DEFAULT_CORPORATE_NUMBER_ASSIGN_TIMEOUT_MS;

  return callApi('POST', '/corporations/assign-corporate-number/async', data, dispatch, false, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: timeoutMs,
  });
}

const getAssignCorporateNumberAsyncStatus = (jobId, dispatch) => {
  return callApi('GET', `/corporations/assign-corporate-number/async/${jobId}`, null, dispatch);
}

const getAssignCorporateNumberAsyncResult = (jobId, dispatch) => {
  return callApi('GET', `/corporations/assign-corporate-number/async/${jobId}/result`, null, dispatch);
}

export const CorporationsApi = {
  getCorporations,
  getCorporationsById,
  postAssignCorporateNumber,
  postAssignCorporateNumberAsync,
  getAssignCorporateNumberAsyncStatus,
  getAssignCorporateNumberAsyncResult,
};



// WEBPACK FOOTER //
// ./src/redux/api/CorporationsApi.js